module.exports = __webpack_public_path__ + "media/images/pc/specials/common/ribbon-d7662d2674dffb94c836fc1cde51a50c.svg";